import React from 'react';
import { ProductsAdvancedFilters } from './ProductsAdvancedFilters';
import type { ProductsFilters } from './ProductsAdvancedFilters';
import { Icon } from '@/shared/icons'
export interface ProductsFilterChipsBarProps {
  filters: ProductsFilters;
  onFiltersChange: (filters: ProductsFilters) => void;
}

export const ProductsFilterChipsBar: React.FC<ProductsFilterChipsBarProps> = ({
  filters,
  onFiltersChange,
}) => {
  return (
    <div
      className="px-6 py-2 flex items-center gap-3"
      style={{
        backgroundColor: 'var(--theme-header-background)',
        borderBottom: '1px solid var(--theme-header-border)',
      }}
    >
      <div
        className="flex items-center gap-1.5 flex-shrink-0"
        style={{ color: 'var(--theme-muted-text)' }}
      >
        <Icon name="filter" className="w-3.5 h-3.5" />
        <span className="text-xs font-medium">Filtros</span>
      </div>

      <div
        className="w-px h-5 flex-shrink-0"
        style={{ backgroundColor: 'var(--theme-header-border)' }}
      />

      <ProductsAdvancedFilters
        filters={filters}
        onFiltersChange={onFiltersChange}
      />
    </div>
  );
};
